import { ChangeDetectionStrategy, Component, inject, Input, OnChanges } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';
import { Award, AwardFeatureService } from '@rma/public/awards/public/api-awards';
import { ProfileRecognitionBadges } from '@rma/public/generic/domain/types';
import { AccomplishmentDetails, AccomplishmentItemComponent, AccomplishmentMapperService } from '@rma/public/profiles/public/legacy';
import { MarketReportAwardComponent } from './ui-market-report-award/market-report-award.component';

@Component({
  selector: 'rma-market-report-recognition',
  templateUrl: './market-report-recognition.component.html',
  styleUrls: ['./market-report-recognition.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MarketReportAwardComponent, AccomplishmentItemComponent, TranslocoPipe],
})
export class MarketReportRecognitionComponent implements OnChanges {
  private readonly accomplishmentMapperService = inject(AccomplishmentMapperService);
  private readonly awardsService = inject(AwardFeatureService);

  @Input() badges: ProfileRecognitionBadges;
  @Input() awards: Award[];

  public accomplishments: AccomplishmentDetails[];
  public awardsLogoImage: string | null;
  public awardYear: string;

  ngOnChanges(): void {
    this.accomplishments = this.accomplishmentMapperService.map(this.badges);
    this.awardYear = this.awardsService.getAwardsName();
    this.awardsLogoImage = this.awardsService.getAwardsLogo();
  }
}
